module.exports = __webpack_public_path__ + "img/5.45dd5470.png";